import NewSupplier from "../../../../components/@users/suppliers/NewSupplier";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SupplierNewPage() {

    return (
        <NewSupplier 
            routeType={routeTypes.retail}
        />
    )
}       